import { useContext } from "react";
import { Outlet, Navigate } from "react-router";
import { AuthContext } from "./AuthContext";

const ProtectedRoutes = () => {
    const user = useContext(AuthContext).user;
    
    return user ?  <Outlet /> : <Navigate to="/login" />
}

export default ProtectedRoutes;